<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleText: '智能聊天机器人'
    }
  },
  components: {},
  mounted(){
    this.$nextTick(()=>{
       var titleDom = document.getElementById('PanleTitle')
       titleDom.text = this.titleText
      })
  }
}
</script>
<style lang="less">
#app {
  color: #2c3e50;
}
</style>
